import styled from 'styled-components';

export const Caption = styled.div`
  padding: 12px 0 9px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};

  small {
    display: block;
  }
`;
